<script setup>
import { ArrowsUpDownIcon } from "@heroicons/vue/20/solid";
</script>

<template>
  <button
    class="mx-[-16px] my-[-1px] inline-flex h-10 items-center justify-center rounded-md px-[16px] py-[1px] text-sm font-medium ring-offset-background transition-colors hover:bg-accent hover:text-accent-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50"
  >
    <slot />
    <ArrowsUpDownIcon class="ml-2 h-4 w-4" />
  </button>
</template>
